import React from 'react';

interface TruncatedTextProps {
  styleProps?: React.CSSProperties;
  text: string;
  prefix?: string;
  disableTruncation?: boolean;
  maxChars?: number;
  showTitle?: boolean;
  htmlId?: string;
}

export const TruncatedText: React.FC<TruncatedTextProps> = ({
  styleProps,
  text,
  prefix,
  disableTruncation = false,
  maxChars,
  showTitle,
  htmlId,
}) => {
  const maxCharsToCheck = maxChars || 0;
  const maxWidth = maxChars !== undefined ? `${maxChars}ch` : '90%';

  return (
    <span
      title={showTitle && text.length > maxCharsToCheck ? text : ''}
      style={styleProps}
    >
      {prefix && <span>{prefix}: </span>}
      <span
        data-testid={htmlId}
        className={
          !disableTruncation
            ? 'inline-block align-middle whitespace-nowrap overflow-hidden text-ellipsis'
            : ''
        }
        style={!disableTruncation ? { maxWidth } : undefined}
      >
        {text}
      </span>
    </span>
  );
};
